module.exports = __webpack_public_path__ + "img/Comic05-1.bcd99b98.png";